import * as angular from 'angular';
import 'angular-translate';
import 'messageformat';
import 'angular-translate-interpolation-messageformat';
import 'angular-i18n/angular-locale_en-gb.js';

export function mixinTranslation(appModule: angular.IModule, availableLanguages: string[], fileName: string) {
    appModule.config(configureTranslateProvider);

    configureTranslateProvider.$inject = ['$translateProvider'];
    function configureTranslateProvider($translateProvider: angular.translate.ITranslateProvider) {

        for (let i = 0; i <= availableLanguages.length - 1; i++) {
            var languageFileName = require(`../../lang/${availableLanguages[i]}/${fileName}-${availableLanguages[i]}.json`);
            $translateProvider.translations(availableLanguages[i], languageFileName);
        }

        $translateProvider
            .addInterpolation('$translateMessageFormatInterpolation')
            .useSanitizeValueStrategy(null)
            .preferredLanguage('en')
            .fallbackLanguage('en');
    }
}




// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/translation.ts